var _a;
const MapBoxAccessToken = 
// @ts-ignore
((_a = window === null || window === void 0 ? void 0 : window.ConfigUtility) === null || _a === void 0 ? void 0 : _a.mapBoxAccessToken) ||
    'pk.eyJ1IjoiY2hyaXNib3lkYnVpbHQiLCJhIjoiY2tidXRsaXg1MDhmODJ0cWlxeGE5dTVqcyJ9.VBMWjlSIlh_uh6fheNrhCw';

export { MapBoxAccessToken };
//# sourceMappingURL=MapboxToken.js.map
